/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_level_label10 = /** @type {(inputs: {}) => string} */ () => {
	return `Levels`
};

const fr_level_label10 = /** @type {(inputs: {}) => string} */ () => {
	return `Niveaux`
};

const de_level_label10 = /** @type {(inputs: {}) => string} */ () => {
	return `Ebenen`
};

const es_level_label10 = /** @type {(inputs: {}) => string} */ () => {
	return `Niveles`
};

const it_level_label10 = /** @type {(inputs: {}) => string} */ () => {
	return `Livelli`
};

const ar_level_label10 = /** @type {(inputs: {}) => string} */ () => {
	return `المستويات`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const level_label10 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.level_label10(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("level_label10", locale)
	if (locale === "en") return en_level_label10(inputs)
	if (locale === "fr") return fr_level_label10(inputs)
	if (locale === "de") return de_level_label10(inputs)
	if (locale === "es") return es_level_label10(inputs)
	if (locale === "it") return it_level_label10(inputs)
	return ar_level_label10(inputs)
};
export { level_label10 as "LEVEL_LABEL" }